import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  backgroundLight,
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { FaXmark } from "react-icons/fa6";
import PatientSelectNew from "../select/PatientSelectNew";

const AddPatientModal = ({
  addPatientModalOpen,
  setAddPatientModalOpen,
  setPatient,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        isOpen={addPatientModalOpen}
        onClose={() => setAddPatientModalOpen(false)}
        isCentered
        autoFocus={false}
      >
        <ModalOverlay />
        <ModalContent
          borderRadius={{ base: "0", md: "1.5rem" }}
          w={{ base: "100%", md: "600px" }}
          minH={{ base: "100%", md: "auto" }}
          maxW="100vw"
          m={0}
          border={`1px solid ${newBorder}`}
        >
          <ModalHeader
            p="1.5rem 1.5rem"
            borderBottom={`1px solid ${newBorder}`}
          >
            <Flex w="100%" align="center" justify="space-between">
              <Text fontSize="1rem" fontWeight="600" color={textPrimary}>
                {/* {t("service.changePriceTitle")} */}
                {t("service.addPatient")}
              </Text>
              <Flex align="center" justify="flex-end" gap="1.5rem">
                <IconButton
                  size="sm"
                  bg={backgroundLight}
                  color={textSecondary}
                  onClick={() => setAddPatientModalOpen(false)}
                  borderRadius="10rem"
                  _hover={{ bg: primaryAlt, color: white }}
                >
                  <Icon as={FaXmark} />
                </IconButton>
              </Flex>
            </Flex>
          </ModalHeader>

          <ModalBody p={["1.5rem 0em 3rem", "1.5rem 1.5rem 3rem"]}>
            <Flex w="100%" p="0 0em">
              <PatientSelectNew
                onChange={setPatient}
                setAddPatientModalOpen={setAddPatientModalOpen}
              />
              {/* <FormControlPatientTestNew
                onChange={(selectedOption) => {
                  console.log("Selected patient ID:", selectedOption.value);
                  // Update your state or perform other actions based on the selected patient
                  // For example:
                  setPatient(selectedOption.value);
                }}
              /> */}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddPatientModal;
